/* Printed Love 3.0 · homepage and collection page behaviour.
   The product cards and the "Ten worlds" room follow one design. The choice is remembered (PL.memory),
   so the product pages open in it. */
(function () {
  'use strict';
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var cardsEl = document.querySelector('[data-h-cards-json]'), CARDS = {};
  try { CARDS = JSON.parse(cardsEl.textContent); } catch (e) {}
  var roomEl = document.querySelector('[data-pl-room-json]'), ROOM = null;
  try { ROOM = JSON.parse(roomEl.textContent); } catch (e) {}
  var design = PL.memory.startDesign() || 'Garden';

  function draw() {
    document.querySelectorAll('[data-h-card]').forEach(function (a) {
      var h = a.getAttribute('data-h-card');
      a.href = '/products/' + h + '?design=' + encodeURIComponent(design);
      var src = CARDS[h] && CARDS[h][design], img = a.querySelector('img');
      if (img && src && img.getAttribute('src') !== src) img.src = src;
      if (img) img.alt = ({ 'everyday-love-blanket': 'Custom pet photo blanket', 'everyday-love-pillow': 'Custom pet photo pillow', 'everyday-love-portrait': 'Custom pet portrait canvas' }[h] || 'Everyday Love') + ' in the ' + design + ' design';
    });
    var W = null, wEl = document.querySelector('[data-pl-worlds-json]'); try { W = JSON.parse(wEl.textContent); } catch (e) {}
    if (!W) return;
    document.querySelectorAll('.h-worlds__rail .pl-look').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.design === design)); });
    var q = '?design=' + encodeURIComponent(design);
    document.querySelectorAll('[data-h-pic]').forEach(function (a) {
      var h = a.getAttribute('data-h-pic'), src = W.photos[h] && W.photos[h][design], img = a.querySelector('img');
      a.href = '/products/' + h + q;
      if (img) { if (src && img.getAttribute('src') !== src) img.src = src; img.alt = ({ blanket: 'Custom pet photo blanket', pillow: 'Custom pet photo pillow', portrait: 'Custom pet portrait canvas' }[W.labels[h].toLowerCase()] || 'Everyday Love') + ' in the ' + design + ' design'; }
    });
    var links = document.querySelector('[data-h-links]');
    if (links) links.innerHTML = '<a class="pl-btn pl-btn--primary" href="/products/everyday-love-blanket' + q + '">Make the blanket in ' + esc(design) + '</a>' +
      '<span class="h-worlds__or">or the <a href="/products/everyday-love-pillow' + q + '">pillow</a> or <a href="/products/everyday-love-portrait' + q + '">portrait</a></span>';
  }
  function set(d) { design = d; PL.memory.set({ design: d }); draw(); }
  document.querySelectorAll('.h-worlds__rail .pl-look').forEach(function (b) { b.addEventListener('click', function () { set(b.dataset.design); }); });
  draw();
})();
